export const rules = new Intl.PluralRules('en-US')

// NOTE: See `console.log(new Intl.PluralRules('en-US').resolvedOptions().pluralCategories)`
export type RulesType = Record<'one' | 'other', string>

export const plural = (count: number, texts: RulesType): string => {
  const category = rules.select(Math.abs(count))
  const template = category in texts ? texts[category as keyof RulesType] : texts.other
  return template.replace(/#/g, String(count))
}
